import { SealQuestionIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FolderQuestion = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SealQuestionIcon {...rest} size={Sizes[size]} color={fill} />;
};

FolderQuestion.displayName = 'FolderQuestion';
